import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

// Import page components
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import AuthPage from './pages/AuthPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import DashboardPage from './pages/DashboardPage'
import EventsPage from './pages/EventsPage'
import PhotosPage from './pages/PhotosPage'
import MembershipPage from './pages/MembershipPage'
import VerifyPage from './pages/VerifyPage'
import ConfigurationPage from './pages/ConfigurationPage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import AdminPage from './pages/AdminPage'
import ThermalMapPage from './pages/ThermalMapPage'
import HeadToHeadPage from './pages/HeadToHeadPage'
import CoachingNotesPage from './pages/CoachingNotesPage'
import TeamPage from './pages/TeamPage'
import NotFoundPage from './pages/NotFoundPage'
import ErrorPage from './pages/ErrorPage'

function App() {
  return (
    <>
      <Helmet>
        <title>FWO Pilot Portal</title>
        <meta name="description" content="FWO Pilot Portal - Paragliding competition management platform" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/verify/:userId" element={<VerifyPage />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/photos" element={<PhotosPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/configuration" element={<ConfigurationPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/thermal-map" element={<ThermalMapPage />} />
        <Route path="/head-to-head" element={<HeadToHeadPage />} />
        <Route path="/coaching-notes" element={<CoachingNotesPage />} />
        <Route path="/team" element={<TeamPage />} />

        {/* Error Routes */}
        <Route path="/500" element={<ErrorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  )
}

export default App
